
function toggleFold(index) {
	let $fold = $w('#folded' + index);
	let $box = $w('#box' + index);
	let $boxOn = $w('#boxOn' + index);
	// toggle the fold at the index
	if ($fold.collapsed) {
		$fold.expand();
		$boxOn.show();
		$box.hide();
	}
	else {
		$fold.collapse();
		$boxOn.hide();
		$box.show();
	}
	// collapse the other folds
	[1,2,3,4,5,6,7,8,9]
		.filter(idx => idx !== index)
		.forEach(idx => {
			$w('#folded' + idx).collapse();
			$w('#box' + idx).show();
			//$w('#boxOn' + idx).collapse();		
		})
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box1_click(event) {
	toggleFold(1);
}
/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box2_click_1(event) {
	toggleFold(2);
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box3_click_1(event) {
    toggleFold(3);
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box4_click_1(event) {
    toggleFold(4); 
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box5_click_1(event) {
 toggleFold(5);
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box6_click_1(event) {
    toggleFold(6);
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box7_click_1(event) {
    toggleFold(7);
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box8_click_1(event) {
	toggleFold(8);
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function box9_click_1(event) {
    toggleFold(9);
}